import { render, staticRenderFns } from "./SystemHealthDashboard.vue?vue&type=template&id=2e4755a2"
import script from "./SystemHealthDashboard.vue?vue&type=script&lang=js"
export * from "./SystemHealthDashboard.vue?vue&type=script&lang=js"
import style0 from "./SystemHealthDashboard.vue?vue&type=style&index=0&id=2e4755a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports